export default __webpack_public_path__ + "static/icon-scroll-4363b765f947393083c967d279d2872a.svg";